import styled from "styled-components";
import Variables from "../../assets/styleVariables";


export const PurchaseContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: ${props=> props.fullPageHeight?"100vh":""};
  max-width: 100vw;
  padding: 10px;
  .purchase-h1 {
    width: 100%;
    margin: 0 auto 8px auto;
    text-align: center;
    font-weight: ${Variables.font_weight.medium};
  }
`;

export const FormContainer = styled.div`
  border-radius: 4px;
  -webkit-box-shadow: 0 0 4px 0 #ccc;
  -moz-box-shadow: 0 0 4px 0 #ccc;
  box-shadow: 0 0 4px 0 #ccc;
  min-width: 448px;
  min-height: 416px;
  margin-top: 8px;
  padding: 12px 32px;
  height: calc(100% - 43px - 64px);
  max-width: 100%;
  //max-width: calc(100vw - 8px);
`;